import { Directive, inject, TemplateRef } from '@angular/core';

@Directive({
  selector: '[issTypeaheadSelectItem]',
  standalone: true,
})
export class TypeaheadSelectItemDirective<TItem, TValue> {
  public readonly templateRef = inject<TemplateRef<{
    $implicit: TValue;
    item: TItem;
  }>>(TemplateRef);
}
